import {createServer, Response} from "miragejs";
import CONFIG from "./config";
import Customer from "./mocks/api/wealth/v1/customer/POST.json";
import customerKeyInformation from "./mocks/api/wealth/v1/customer/__key__/information/GET.json";
import customerKeyOfferGet from "./mocks/api/wealth/v1/customer/__key__/offer/GET.json";
import SendNotification from "./mocks/api/wealth/v1/notification/__key__/POST.json";
import EmailValidate from "./mocks/api/wealth/v1/email/validate/POST.json";
import DocumentsData from "./mocks/api/wealth/v1/documents/data/POST.json";
import DocumentsGenerate from "./mocks/api/wealth/v1/documents/generate/POST.json";
import BundleExecutive from "./mocks/api/wealth/v1/bundle/execute/POST.json";
import CreateProduct from "./mocks/api/wealth/v1/create/__key__/product/PUT.json";
import createActivaCookie from "./mocks/api/wealth/v1/cookie/__key__/activa/GET.json";

const URL = CONFIG.API.WealthServices;

export function makeServer({environment = "test"} = {}) {
    return createServer({
        environment,
        routes() {
            this.namespace = URL;
            /**Customer*/
            this.post("/v1/create/prospect", (_, request) => {
                let rsp;

                rsp = new Response(401, undefined, Customer.CustomerNotFound);

                const data = JSON.parse(request.requestBody);

                if (data.prospect_id === "27067881-5") {
                    rsp = new Response(200, undefined, Customer.CustomerSubjectId);
                }

                if (data.prospect_id === "11111111-1") {
                    rsp = new Response(401, undefined, Customer.CustomerInvalid);
                }

                return rsp;
            });
            /**CustomerInformation*/
            this.get("/v1/prospect/:id/information", (_, request) => {

                const data = request.params;

                if (data.id === "ec9d568e-c3bc-384e-b30b-ebce3cdae444") {
                    return new Response(200, undefined, customerKeyInformation.CustomerInformationSuccess);
                } else {
                    return new Response(401, undefined, customerKeyInformation.CustomerInformationInvalid);
                }
            });

            /**ValidateEmail*/
            this.get("/v1/prospect/:id/validation/:email", (_, request) => {
                let rsp;

                const data = request.queryParams;

                rsp = new Response(500, undefined, EmailValidate.EmailValidateFailed);

                if (data.email === "john.doe@scotiabank.com") {
                    rsp = new Response(
                        200,
                        undefined,
                        EmailValidate.EmailValidateInvalid
                    );
                }

                if (data.email === "john.doe@scotiabank.cl") {
                    rsp = new Response(
                        200,
                        undefined,
                        EmailValidate.EmailValidateSuccess
                    );
                }

                return rsp;
            });

            /**CustomerOffer */
            this.get("/v1/prospect/:id/offer", () => {
                return new Response(200, undefined, customerKeyOfferGet);
            });

            /**SendNotification*/
            this.post("/v1/notification/:id", (_, request) => {
                let rsp;

                const data = request.params;

                if (data.id === "ec9d568e-c3bc-384e-b30b-ebce3cdae444") {
                    rsp = new Response(
                        200,
                        undefined,
                        SendNotification.NotificationSuccess
                    );
                } else {
                    rsp = new Response(401, undefined, SendNotification.NotificationFailed);
                }

                return rsp;
            });

            /**ValidateNotification*/
            this.get(
                "/v1/notification/:key?transaction_id=:transaction_id&code=:code",
                (_, request) => {
                    let rsp;

                    rsp = new Response(
                        401,
                        undefined,
                        SendNotification.NotificationFailed
                    );

                    const data = request.queryParams;

                    if (
                        data.transaction_id ===
                        "5530bad2a4ebf8663b51ac9c4bf3b6bda958faf25a77297c4ec56f117eae43d5" &&
                        data.code !== "1234"
                    ) {
                        rsp = new Response(
                            401,
                            undefined,
                            SendNotification.NotificationInvalid
                        );
                    }

                    if (
                        data.transaction_id ===
                        "5530bad2a4ebf8663b51ac9c4bf3b6bda958faf25a77297c4ec56f117eae43d5" &&
                        data.code === "1234"
                    ) {
                        rsp = new Response(
                            200,
                            undefined,
                            SendNotification.NotificationSuccess
                        );
                    }

                    return rsp;
                }
            );

            /**createActivaCookie*/
            this.get("/v1/cookie/:id/activa", (_, request) => {

                let rsp;

                rsp = new Response(401, undefined, createActivaCookie.CreateActivaCookieInvalid);

                const data = request.params;

                if (data.id === "ec9d568e-c3bc-384e-b30b-ebce3cdae444") {
                    rsp = new Response(200, undefined, createActivaCookie.CreateActivaCookieSuccess);
                }

                return rsp;
            });

            /*firma de contratos*/
            this.post("/v1/bundle/execute", () => {
                return new Response(200, undefined, BundleExecutive);
            });
            this.post("/v1/documents/generate", () => {
                return new Response(200, undefined, DocumentsGenerate);
            });
            this.post("/v1/documents/data", () => {
                return new Response(200, undefined, DocumentsData);
            });
            this.put("/v1/create/:id/product", () => {
                return new Response(200, undefined, CreateProduct);
            });
        },
    });
}
